import { render, staticRenderFns } from "./disabilitas.vue?vue&type=template&id=63623744"
import script from "./disabilitas.vue?vue&type=script&lang=js"
export * from "./disabilitas.vue?vue&type=script&lang=js"
import style0 from "./disabilitas.vue?vue&type=style&index=0&id=63623744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports